import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

import { FsDialogModule } from '@firestitch/dialog';
import { FsFormDirective, FsFormModule } from '@firestitch/form';
import { FsSkeletonModule } from '@firestitch/skeleton';

import { of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

import { ProjectData, StatusData } from '@common/data';
import { Project, Status } from '@common/interfaces';
import { SessionService } from '@common/services';

import { StatusMenuComponent } from '../../../status-menu/components/status-menu/status-menu.component';


@Component({
    templateUrl: './project-create.component.html',
    styleUrls: ['./project-create.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        FormsModule,
        FsFormModule,
        FsDialogModule,
        MatDialogTitle,
        CdkScrollable,
        MatDialogContent,
        MatFormField,
        MatLabel,
        MatInput,
        StatusMenuComponent,
        MatDialogActions,
        MatButton,
        MatDialogClose,
        FsSkeletonModule,
    ]
})
export class ProjectCreateComponent implements OnInit {
  private _data = inject(MAT_DIALOG_DATA);
  private _projectData = inject(ProjectData);
  private _dialogRef = inject<MatDialogRef<ProjectCreateComponent>>(MatDialogRef);


  @ViewChild(FsFormDirective)
  public form: FsFormDirective = null;

  public project: Project;
  public defaultStatus: Status;

  private _statusData = inject(StatusData);
  private _sessionService = inject(SessionService);
  private _cdRef = inject(ChangeDetectorRef);

  public ngOnInit(): void {
    this._fetchData();
  }

  public statusChanged(data: Status): void {
    this.project.status = data;
    this.project.statusId = data ? data.id : null;
  }

  public nameChanged(): void {
    if (!this.form.ngForm.controls.abr.dirty) {
      let abr = this.project.name.toUpperCase();

      if (abr.match(/\s/)) {
        abr = abr.match(/\b(\w)/g).join('');
      }

      this.project.abr = abr.slice(0, 3);
    }
  }

  public abrKeyup(event): void {
    this.project.abr = event.target.value.toUpperCase();
  }

  public save = () => {
    return this._projectData.save(this.project)
      .pipe(
        tap((response) => {
          this._dialogRef.close(response);
        }),
      );
  };

  private _fetchData(): void {
    of(true)
      .pipe(
        switchMap(() => {
          return this._statusData.gets({ 
            class: 'project',
            environmentId: this._sessionService.environmentId(),
            default: true,
          })
            .pipe(
              tap((statuses) => {
                this.defaultStatus = statuses[0];
              }),
            );
        }),
      )
      .subscribe(() => {
        this.project = {
          id: null,
          statusId: this.defaultStatus?.id,
          status: this.defaultStatus,
        };
        this._cdRef.markForCheck();
      });
  }

}
